import { ProductCategory } from '@api/ProductCategories/ProductCategory';
import ProductCategoryServ from '@api/ProductCategories/ProductCategoryServ';

class ProductCategoriesService {
    saveProductCategory = (productCategory: ProductCategory): Promise<ProductCategory> => {
        return new Promise(async (resolve, reject) => {
            try {
                const data = await ProductCategoryServ.saveProductCategory(productCategory);
                resolve(data);
            } catch (error) {
                reject('Error saving product category: ' + error);
            }
        });
    };
    updateProductCategoriesOrder = (productCategories: ProductCategory[]): Promise<void> => {
        return new Promise(async (resolve, reject) => {
            try {
                await ProductCategoryServ.updateProductCategoriesOrder(productCategories);
                resolve();
            } catch (error) {
                reject('Error saving product categories order: ' + error);
            }
        });
    };
    getProductCategories = (): Promise<ProductCategory[]> => {
        return new Promise(async (resolve, reject) => {
            try {
                const data = await ProductCategoryServ.getProductCategories();
                resolve(data);
            } catch (error) {
                reject('Error getting product categories: ' + error);
            }
        });
    };
    getProductCategory = (productCategoryId: string): Promise<ProductCategory> => {
        return new Promise(async (resolve, reject) => {
            try {
                const ProductCategory = await ProductCategoryServ.getProductCategory(productCategoryId);
                resolve(ProductCategory);
            } catch (error) {
                reject('Error getting product category: ' + error);
            }
        });
    };

    deleteProductCategory = (productCategoryId: string): Promise<void> => {
        return new Promise(async (resolve, reject) => {
            try {
                await ProductCategoryServ.deleteProductCategory(productCategoryId);
                resolve();
            } catch (error) {
                reject('Error deleting product category: ' + error);
            }
        });
    };
}
export default ProductCategoriesService;
